module.exports = __webpack_public_path__ + "img/Villa_Borna_27.0ccc8ad4.jpg";